import { ReceiverDetailsProps } from 'contexts/messagesContext/messagesContext.types';

import UserAvatar from 'assets/icons/doc-avatar.svg';

export const DEFAULT_MESSAGE = {
  _id: '',
  buttons: [],
  channelId: '',
  message: 'Welcome to LifeMD Messages! Use this space for health related questions.',
  messageStatus: {
    seen: null,
    sent: new Date()
  },
  receiverDetails: [{} as ReceiverDetailsProps],
  senderDetails: {
    email: '',
    id: '',
    name: 'LifeMD',
    profileImage: UserAvatar,
    status: '',
    userType: {
      name: '',
      shortCode: ''
    }
  }
};
